import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import MetConstants from "../../inumet_js_lib/model/datosVars/metConstants";
import Variable from "../../inumet_js_lib/model/variables/variable";
import Periodicidad from "../../inumet_js_lib/model/tipos/periodicidad";
import DatosVars from "../../inumet_js_lib/model/datosVars/datosVars";
import DateUtils from "../../inumet_js_lib/utils/dateUtils";
import TypesUtils from "../../inumet_js_lib/utils/typesUtils";

class GraficaDatosVars extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let idVar =
            TypesUtils.isArray(this.props.variable) &&
            this.props.variable.length > 0
                ? this.props.variable[0].id
                : this.props.variable.id;
        let esVarDiaria =
            this.props.variable &&
            !TypesUtils.isArray(this.props.variable) &&
            this.props.variable.periodicidad === Periodicidad.day;
        let type = MetConstants.apexChartsType[idVar];
        if (!type) type = "line";
        let options = {
            chart: {
                type: type,
                height: "100%",
                width: "100%",
                shadow: {
                    enabled: true,
                    color: "#2d353c",
                    top: 0,
                    left: 0,
                    blur: 10,
                    opacity: 1,
                },
                toolbar: {
                    show: true,
                    tools: {
                        download: false,
                        selection: false,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: false,
                        reset:
                            true |
                            '<img src="/static/icons/reset.png" width="20">',
                        customIcons: [],
                    },
                },
                animations: {
                    enabled: false,
                },
            },
            title: {
                text: this.props.title,
                offsetY: 20,
                style: {
                    fontWeight: 900,
                },
                align: "center",
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "55%",
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "straight",
                width: 3,
            },
            grid: {
                row: {
                    colors: ["rgba(182, 194, 201, 0.1)", "transparent"], // takes an array which will be repeated on columns
                    opacity: 0.5,
                },
            },
            markers: {
                size: 4,
            },
            xaxis: {
                categories: [],
                type: "datetime",

                axisBorder: {
                    show: true,
                    color: "rgba(182, 194, 201, 0.5)",
                    height: 1,
                    width: "100%",
                    offsetX: 0,
                    offsetY: -1,
                },
                axisTicks: {
                    show: true,
                    borderType: "solid",
                    color: "#b6c2c9",
                    height: 6,
                    offsetX: 0,
                    offsetY: 0,
                },
                labels: {
                    format: "dd/MM",
                    showDuplicates: false,
                    datetimeFormatter: {
                        year: "yyyy",
                        month: "MM/yy",
                        day: "dd/MM",
                        hour: "HH:mm",
                    },
                    show: true,
                },
            },
            yaxis: {
                decimalsInFloat: 2,
                show: true,
            },
            tooltip: {
                shared: false,
                x: {
                    formatter: (val) => {
                        if (esVarDiaria) return DateUtils.latinD(val);
                        return DateUtils.latinDT(val);
                    },
                },
            },
            legend: {
                show: true,
                position: "bottom",

                containerMargin: {
                    top: 30,
                    bottom: 30,
                },
                horizontalAlign: "left",
                floating: false,
            },
        };
        let varsGrafica = [];
        let multiVars = false;
        if (TypesUtils.isArray(this.props.variable)) {
            varsGrafica.push(...this.props.variable);
            multiVars = this.props.variable.length > 1;
        } else {
            varsGrafica.push(this.props.variable);
        }
        let multiEstac = this.props.estaciones.length > 1;
        let height = "auto";
        if (this.props.height) height = this.props.height;
        let datasets = [];
        varsGrafica.forEach((variable) => {
            this.props.estaciones.forEach((estacion) => {
                let dataset = {};
                let label = "";
                if (multiEstac) label = estacion.nombre;
                if (multiVars) {
                    if (label !== "") label += " - ";
                }
                label += variable.nombre;
                dataset.name = label;

                /* if (esVarDiaria) {
                    let fechasYdatos = this.props.datosVars.getArrayDeFechasYDatos(
                        variable.id,
                        estacion.id,
                        (date) => {
                            if (
                                variable.id ===
                                MetConstants.VAR_ID_PRECIPR3_24H_ACUM
                            ) {
                                date = DateUtils.addHours(date, 3);
                            }
                            return DateUtils.latinD(date)
                        }
                    );
                    dataset.data = fechasYdatos.datos;
                    if (categories.length < fechasYdatos.fechas.length)
                        categories = fechasYdatos.fechas;
                } else {*/
                dataset.data = this.props.datosVars.serieXFechasYDatosIds(
                    variable.id,
                    estacion.id,
                    (dateStr) => {
                        let date = DateUtils.parseDate(dateStr);
                        if (
                            variable.id ===
                            MetConstants.VAR_ID_PRECIPR3_24H_ACUM
                        ) {
                            date = DateUtils.addHours(date, 3);
                            date = Periodicidad.truncarAPeriodicidad(
                                date,
                                variable.periodicidad
                            );
                        }
                        return date.valueOf();
                    },
                    { TRAZA: 0.1 }
                );
                //}
                datasets.push(dataset);
            });
        });

        return (
            <Chart
                height={height}
                type={type}
                width="100%"
                options={options}
                series={datasets}
            />
        );
    }
}

GraficaDatosVars.propTypes = {
    variable: PropTypes.oneOfType([
        PropTypes.instanceOf(Variable),
        PropTypes.array,
    ]),
    datosVars: PropTypes.instanceOf(DatosVars),
    estaciones: PropTypes.arrayOf(PropTypes.object),
    height: PropTypes.number,
    graficasCombinadasVars: PropTypes.array,
    title: PropTypes.string,
};

export { GraficaDatosVars as default };
